import { createApiRef } from '@backstage/core-plugin-api';
import {
  UnregisterApplianceResponse,
  CasApplianceResponse,
  DamsApplianceResponse,
  EcpApplianceResponse,
  UserAppliancesResponse,
  RegisterApplianceResponse,
  UserCredentials,
  UnregisterRequest,
  RegisterRequest,
} from './types';

/** @public */
export const OcpApplianceRegistrationApiRef =
  createApiRef<OcpApplianceRegistrationApi>({
    id: 'backstage.plugin.ocp-appliance-registration.service',
  });

/** @public */
export interface OcpApplianceRegistrationApi {
  postUserAppliances(
    credentials: UserCredentials,
  ): Promise<UserAppliancesResponse>;
  searchApplianceByIdEcp(
    credentials: UserCredentials,
    applianceId: string,
  ): Promise<EcpApplianceResponse>;
  searchApplianceByIdCas(
    credentials: UserCredentials,
    applianceId: string,
  ): Promise<CasApplianceResponse>;
  searchApplianceByIdDams(
    credentials: UserCredentials,
    applianceId: string,
  ): Promise<DamsApplianceResponse>;
  unregisterAppliance(
    request: UnregisterRequest,
    applianceId: string,
  ): Promise<UnregisterApplianceResponse>;
  registerAppliance(
    request: RegisterRequest,
    applianceId: string,
  ): Promise<RegisterApplianceResponse>;
}
